import React from "react";
import MyBarcode from "../components/MyBarcode";
const GenerateBarcode = () => {
  return <MyBarcode />;
};

export default GenerateBarcode;
